import { render, staticRenderFns } from "./InspeccionForm.vue?vue&type=template&id=bb15ce96"
import script from "./InspeccionForm.vue?vue&type=script&lang=ts"
export * from "./InspeccionForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports